import { updatesData } from '@/mocks/home';

export default function SectionUpdates() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="flex items-center gap-3 mb-10">
          <div className="w-10 h-10 flex items-center justify-center bg-primary-100 rounded-lg">
            <i className="ri-flashlight-line text-primary-600 text-lg"></i>
          </div>
          <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-900">
            吃瓜快讯
          </h2>
          <span className="flex items-center gap-1 text-xs text-primary-600 bg-primary-50 px-2.5 py-1 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-primary-500 animate-pulse"></span>
            实时更新
          </span>
        </div>

        <div className="relative pl-6 border-l-2 border-background-200">
          {updatesData.map((item, i) => (
            <div
              key={item.id}
              className={`relative pb-8 last:pb-0 ${
                i < updatesData.length - 1 ? 'mb-2' : ''
              }`}
            >
              <div className={`absolute -left-[calc(1.5rem+5px)] top-1 w-3 h-3 rounded-full border-2 border-background-50 ${
                item.hot ? 'bg-primary-500 border-primary-300' : 'bg-secondary-400 border-secondary-200'
              }`}></div>

              <div className="bg-background-100 rounded-xl p-4 md:p-5 hover:bg-background-200/70 transition-colors cursor-pointer">
                <div className="flex flex-wrap items-center gap-2 md:gap-3 mb-2">
                  <span className="text-xs text-foreground-500">{item.time}</span>
                  <span className={`text-xs px-2 py-0.5 rounded-full font-medium ${
                    item.hot
                      ? 'bg-primary-100 text-primary-700'
                      : 'bg-secondary-100 text-secondary-700'
                  }`}>
                    {item.category}
                  </span>
                  {item.hot && (
                    <span className="flex items-center gap-1 text-xs text-accent-700 bg-accent-100 px-2 py-0.5 rounded-full">
                      <i className="ri-fire-line text-[10px]"></i>热
                    </span>
                  )}
                </div>
                <p className="text-sm md:text-base text-foreground-900 font-medium leading-relaxed">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}